export enum PathfindersFlags {
    MarginCalculatorGsaSpotOn = 'margin-calculator-gsa-spot-on',
    ExpandedShiftLength = 'expanded-shift-length',
    OfferAltWeeklyPay = 'offer-alt-weekly-pay',
    RecruitingGsaLookup = 'recruiting-margin-gsa-lookup',
    TravelContractsGsaLookup = 'travel-contracts-margin-gsa-lookup',
    GsaAdminTool = 'gsa-admin-tool',
    GsaImport = 'gsa-import',
    ShowJobIdOnMarginCalculator = 'show-job-id-on-margin-calculator',
    ContractRequestCompleteCheck = 'contract-request-complete-check',
    MarginCalculatorCopyToClipboard = 'margin-calculator-copy-to-clipboard',
    PremiumBillRatesChangingSpecialtyFix = 'premium-bill-rates-changing-specialty-fix',
    MarginCalculatorJobResetAltShift = 'margin-calculator-job-reset-alt-shift',
    ScContractDaysDisplay = 'sc-contract-days-display',
    MinimumBasePayPinkValidation = 'minimum_base_pay_pink_validation',
    FacilityNameErrorHandling = 'facility-name-error-handling',
    LoadingSavedVacationWeeks = 'loading-saved-vacation-weeks',
    RotatingShiftsPayHoursFix = 'rotating-shifts-pay-hours-fix',
    MarginCalculatorMinimumWage = 'margin-calculator-minimum-wage',
    BillingProfileRotatingShiftFix = 'billing-profile-rotating-shift-fix',
    OfferMarginSpecialtyFix = 'offer-margin-specialty-fix',
    RotatingShiftsSecondShiftFix = 'rotating-shifts-second-shift-fix',
    LoadPreviousProfessionFix = 'load-previous-profession-fix',
    ContractRemoveCustomizedSection = 'contract-remove-customized-section',
    EnableInsuranceCosts2025View = 'enable-insurance-costs-2025-view',
    MarginCalculatorMinWageValidatorEnabled = 'margin-calculator-min-wage-validator-enabled',
    RoundStipendsFix = 'round-stipends-fix',
    UcHealthSystemDocumentVersion = 'uc-health-system-document-version',
    UcHealthSystemDocumentDynamicVersions = 'uc-health-system-document-dynamic-versions',
    ExtendedMinimumWage = 'extended-minimum-wage',
    MinimumWageViolationCheck = 'minimum-wage-violation-check',
    MinimumWageAdminTool = 'minimum-wage-admin-tool',
    StipendsSoftPinkValidation = 'stipends-soft-pink-validation',
    DontUpdatePremiumPayRateAfterPayRateChanged = 'dont-update-premium-pay-rates-after-payrate-changed',
    DisplayPayPackageAdditionalFields = 'display-paypackage-additional-fields',
    MarginValidationLogging = 'margin-validation-logging',
    AllowZeroDollarPremiumPayRates = 'allow-zero-dollar-premium-pay-rates',
    SoftStopForExistingContractRequest = 'soft-stop-for-existing-contract-request',
    NgRxMarginAndOrDBValueFix = 'ngrx-margin-andor-db-value-fix',
    MarginAyaPaidBonus = 'margin-aya-paid-bonus',
    DisablePipelinedMarginUpdate = 'disable-pipelined-margin-update',
    DisableSendAfterContractIsSent = 'disable-send-after-contract-is-sent',
    ContractRequestEmailRecruiterFix = 'contract-request-email-recruiter-fix',
    FacilityStateClassifications = 'facility-state-classifications',
    MarginCalculatorBlockSaveWhenOverRTOLimit = 'margin-calculator-block-save-when-over-rto-limit',
    StopAltBaseBillRateForStandardShifts = 'stop-alt-base-bill-rate-for-standard-shifts',
    RemoveWeeksCheckWhenLoadingBillingRates = 'remove-weeks-check-when-loading-billing-rates',
    EnableCOCComparisonFrom = 'enable-coc-comparison-from',
    MaxRtoOnExtensionContracts = 'max-rto-on-extension-contracts',
    MoneyMovementRulesEngine = 'money-movement-rules-engine',
    CandidateChangeNoBillRateReset = 'candidate-change-no-bill-rate-reset',
    SavingOTPremiumMargin = 'saving-ot-premium-margin',
    EnableRTOAlertMessage = 'alertmessage-rto-on-contractstartdate-contractenddate',
    PinkStipendsContractRequestApprovalCheck = 'pink-stipends-contract-request-approval-check',
    FacilityNameErrorInExistingMarginFix = 'facility-name-error-in-existing-margin-fix',
    EnableAyaPaidBonusCoCApprovalWorkFlow = 'enable-aya-paid-bonus-CoC-approval-workflow'
}
